import { makeStyles } from "@material-ui/core/styles"

export default makeStyles((theme) => ({
  defaultMainContainer: {
    // this is static height of AppBar
    paddingTop: "64px"
  },
  defaultMainContainer2: {
    display: "flex",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    flexDirection: "column",
    // 100vh without, AppBar (64px), Headband (80px), and  Footer (50px)
    minHeight: "calc(100vh - 64px - 80px - 50px)"
  },
  defaultMainContainer3: {
    display: "flex",
    flexDirection: "column",
    paddingBottom: theme.spacing(3),
    // 100vh without Footer (50px)
    minHeight: "calc(100vh - 50px)"
  },
  headband: {
    display: "flex",
    alignItems: "center",
    backgroundColor: theme.palette.common.mainVariant1,
    minHeight: "80px",
    maxHeight: "80px",
    boxShadow:
      "0px 2px 4px -1px rgba(0,0,0,0.2)," +
      "0px 4px 5px 0px rgba(0,0,0,0.14)," +
      "0px 1px 10px 0px rgba(0,0,0,0.12)"
  },
  headbandContent: {
    display: "flex",
    alignItems: "center",
    color: theme.palette.text.contrastText,
    "& .skeleton-warning": {
      // handle properly the very specific widget in AM pages for KPI indicators
      // see src/pages/assetmanagement/templates/FundKPIs
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      overflow: "hidden",
      maxHeight: 62,
      height: 62,
      padding: `${theme.spacing(1)}px ${theme.spacing(4)}px`
    },
    "& .infosHeader": {
      // handle properly the very specific widget in AM pages for KPI indicators
      // see src/pages/assetmanagement/templates/FundKPIs
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      overflow: "hidden",
      maxHeight: 62,
      height: 62,
      padding: `${theme.spacing(1)}px ${theme.spacing(4)}px`
    }
  },
  buttonMargin: {
    marginRight: theme.spacing(1)
  },
  formButtonContainer: {
    padding: `${theme.spacing(2)}px 0`,
    display: "flex",
    alignItems: "center",
    "& button:not(:last-child)": {
      marginRight: theme.spacing(1)
    }
  },
  leftButtonGroup: {
    alignSelf: "flex-start",
    flexGrow: 1
  },
  formButton: {
    padding: `${theme.spacing(2)}px 0`,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    // add margin right to all buttons except last one
    "& button:not(:last-child)": {
      marginRight: theme.spacing(1)
    }
  },
  formWidth: {
    width: 500
  }
}))
